export const TIPO_FIRMANTES_SERV_PUB = 1;
export const TIPO_FIRMANTES_JUNTA_LOCAL = 2;
export const TIPO_FIRMANTES_REPRESENTANTE = 3;
export const TIPO_FIRMANTES_VERIFICADOR = 4;
export const TIPO_FIRMANTES_COMPARECIENTE = 5;
export const TIPO_FIRMANTES_SERV_EVENTO = 6;
export const TIPO_FIRMANTES_TESTIGOS = 7;
export const TIPO_FIRMANTES_DESIGNADO = 8;
